import PERMISSIONS from '@/common/permissions';
import { useHasAccess } from '@/modules/core';

const usePlanOmnibusBalanceVisible = () => {
  const isHasPermission = useHasAccess([{ permission: PERMISSIONS.VIEW_OMNI_BALANCES }]);
  return isHasPermission;
};

export default usePlanOmnibusBalanceVisible;
